import { parrotApi } from '@libs/openapi';
import { useSignPersonalMessage } from '@mysten/dapp-kit';
import { findLocationSearch } from '@utils/location-search';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAddress } from './use-address';

export const useSignCode = () => {
  const location = useLocation();
  const address = useAddress();
  const navigate = useNavigate();
  const { mutateAsync: signMessage } = useSignPersonalMessage();
  const code = findLocationSearch(location.search.replace('?', ''), 'code');

  const signCode = async () => {
    if (code && address) {
      const result = await parrotApi.post('/vault/invite/nonce', {
        body: {
          wallet: address,
        },
      });
      const signResult = await signMessage({
        message: new TextEncoder().encode(result.nonce),
      });

      await parrotApi.post('/vault/invite/invited', {
        body: {
          code,
          wallet: address,
          signature: signResult.signature,
        },
      });
      navigate('/earn');
    }
  };

  useEffect(() => {
    signCode();
  }, [code, address]);
};
